// export const API = "http://localhost:3003"
export const API = process.env.REACT_APP_BACKEND_URL!
